var map = {
	"./Icon_question.svg": "a459",
	"./accessory.svg": "6b69",
	"./add.svg": "c2a3",
	"./baseline_people_item.svg": "dc34",
	"./default_no.svg": "d7a9",
	"./default_suo.svg": "c783",
	"./icon_pass.svg": "5d2a",
	"./icon_play.svg": "491d",
	"./img_zanwu.svg": "675d",
	"./logo.svg": "bb69",
	"./logo2.svg": "1d37",
	"./process_icon_attribute.svg": "203c",
	"./process_icon_number.svg": "58db",
	"./process_icon_pass.svg": "d9a9",
	"./process_icon_upload.svg": "f123",
	"./refresh.svg": "b8c4",
	"./right-menu-attribute.svg": "8edb",
	"./right-menu-search.svg": "737d",
	"./right-menu-structure-tree.svg": "642f",
	"./sandclock.svg": "e091",
	"./state_delete.svg": "bad9",
	"./state_editor.svg": "9126",
	"./state_guanlian.svg": "e49c",
	"./state_pass.svg": "7bc6",
	"./training_icon_add.svg": "8727",
	"./training_icon_close.svg": "0581",
	"./training_icon_guanlian.svg": "a08b",
	"./training_icon_jiechu.svg": "da78",
	"./training_icon_new.svg": "fb0a",
	"./training_icon_picture.svg": "e4b8",
	"./training_icon_set.svg": "55d8",
	"./training_icon_shijiao.svg": "5b140"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";